module.exports = __webpack_public_path__ + "img/time.f038f015.png";